/**
 * shadcn's `<Select>` cannot accept an empty string as an item value
 * (it treats `""` as "unselected" and refuses to render the option),
 * so nullable single-select pickers need a sentinel that stands in
 * for `null` / "no selection". Every site that hosts such a picker
 * must use the same sentinel so a stray hand-typed `'__none__'`
 * isn't mistaken for a real value.
 *
 * UUID/text id values cannot collide with the sentinel — it's
 * doubly-underscored on both ends, intentionally outside any
 * realistic identifier format.
 */
export const SELECT_NONE = '__none__' as const;
export type SelectNone = typeof SELECT_NONE;

/** Form value (`string | null`) → Select value (`string`). */
export function toSelectValue(v: string | null | undefined): string {
  return v ?? SELECT_NONE;
}

/** Select value (`string`) → Form value (`string | null`). */
export function fromSelectValue(v: string): string | null {
  return v === SELECT_NONE ? null : v;
}
